<template>
    <div class="findPwd">
       <forget-pwdTitle :active="2"></forget-pwdTitle>
        <div class="findPwd-page_main">
            <el-form class="findPwd-page_form"  label-width="80px" :model="ruleForm" ref="ruleForm">
                 <el-form-item prop="pwd" label="新密码" :error="pwdErr">
                    <el-input v-model="ruleForm.pwd" type="password" placeholder="请输入" @focus="clearErr('pwdErr')" maxlength="25"></el-input>
                    <p class="tips"> 8-16个字符且至少包含三种字符：大写字母、小写字母、符号（不包含&amp;）和数字</p>
                </el-form-item>
                <el-form-item prop="pwd2" label="确认密码"  :error="pwd2Err">
                    <el-input v-model="ruleForm.pwd2" type="password" placeholder="确认密码"  @focus="clearErr('pwd2Err')" maxlength="25"></el-input>
                    <p class="tips"> 请再次填写密码</p>
                </el-form-item>
                <div class="findPwd-page_submit">
                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                </div>
            </el-form>

        </div>

    </div>
</template>

<script>
import ForgetPwdTitle from "../../public/forgetPwdTitle";
export default {
  name: "findPwdStep3",
  components: {
    forgetPwdTitle: ForgetPwdTitle
  },
  data() {
    return {
      ruleForm: {
        xgh: "",
        pwd: "",
        pwd2: ""
      },
      pwdErr: "",
      pwd2Err: ""
    };
  },
  methods: {
    submitForm() {
      const self = this;
      const PwdPatrn = str => {
        const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
        return reg.exec(str);
      };
      const regPWD = /&/;
      if (!self.ruleForm.pwd) {
        self.pwdErr = "请输入密码";
      } else if (!self.ruleForm.pwd2) {
        self.pwd2Err = "请再次输入密码";
      } else if (self.ruleForm.pwd != self.ruleForm.pwd2) {
        self.pwd2Err = "两次输入的密码不一致";
      } else {
        if (!PwdPatrn(self.ruleForm.pwd)) {
          self.pwdErr = "密码格式不正确";
        } else if(regPWD.test(self.ruleForm.pwd)){
          self.pwdErr = "密码格式不正确";
        }else {
          const xgh = localStorage.getItem("findPwdXGH");
          const token = localStorage.getItem("findPwdToken");
          const phone = localStorage.getItem("phone");
           const code = localStorage.getItem("code");
          // const token = "df86836ce72a44d4a67a2a3618706199"
          if (!xgh || !token) {
            // if (token) {
            self.$alert("会话失效，请重新找回密码", "错误提示", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
              customClass: "errMessage",
              callback: self.$router.push({ name: 'Step1'})
            });
          } else {
            // const url = "/email/updatePwd";
            const url = "/email/updateEmailPwd"
            // debugger
            const param = {
              xgh: xgh,
              password: self.ruleForm.pwd,
              // token: self.md5(token),
              token:token,
              phoneNo:phone,
              code:code
            };

            const params = JSON.stringify(param);

            self.postRequest(url, params).then(result => {

              if (result.data && result.data.msgStatus == 1) {
                self.$router.push({ name: 'Step4'});
              } else {
                self.$alert("会话失效，请重新找回密码", "错误提示", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true,
                  customClass: "errMessage",
                  callback: self.$router.push({ name: 'Step1'})
                });
              }
            });
          }
        }
      }
    },
    clearErr(val) {
      if (val == "pwdErr") {
        this.pwdErr = "";
      } else if (val == "pwd2Err") {
        this.pwd2Err = "";
      }
    }
  },
  mounted() {
    const self = this;
    const findPwdToken = localStorage.getItem("findPwdToken");
    if (!findPwdToken) {
      self.$router.push({ name: 'Step1'});
      self.$alert("认证身份信息已过期，请重新验证", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Step1'});
        }
      });
    }
  }
};
</script>

<style scoped>
.forgetPwd {
  width: 100%;
}
.tips {
  padding: 0;
  line-height: 25px;
  color: #999;
  font-size: 12px;
  width: 400px;
}
.findPwd-page_main {
  width: 782px;
  margin: 0 auto;
  background: #fbfbfd;
  margin-top: 50px;
  padding: 50px 0;
}
.findPwd-page_form {
  width: 440px;
  margin: 0 auto;
}
.findPwd-page_submit {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.findPwd-page_submit button {
  width: 130px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  color: #fff;
  font-size: 16px;
}
@media (max-width: 767px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
  .findPwd-page_main{
    width: 96%;
    margin-top: 20px;
    padding:20px 0 !important;
  }
  /deep/ .el-form-item__label{
    font-size: 0.8rem;
  }
  .emailAddr{
    width: 55%;
    font-size: 0.8rem;
  }
  .emailName{
    font-size: 0.8rem;
    width: 45%;
  }
  .findPwd-page_form{
    width: 96%;
  }
  .findPwd-page_submit{
    margin-top: 20px;
  }
  .tips{
    width: 100%;
  }
  .findPwd-page_submit button{
    font-size: 0.8rem;
    display:flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 30px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .findPwd{
    display:flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    height: 100vh;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/step3.vue